import type { InterludeTypes } from "@/interlude";

type ChannelStatus = InterludeTypes["ChannelWithInformation"]["status"];

/**
 * Channel statuses that need someone to act: reconnect, fix a warning, or
 * finish setting up. The Channels page filter, the side menu badge and the
 * Overview all use this one set, so their counts agree.
 */
export const NEEDS_ATTENTION_STATUSES: ReadonlySet<ChannelStatus> =
  new Set<ChannelStatus>([
    "disconnected",
    "token-expired",
    "warning",
    "suspended",
    "restricted",
    "not_set",
  ]);

export const countChannelsNeedingAttention = (
  channels: ReadonlyArray<{ status: ChannelStatus }>,
): number =>
  channels.filter((channel) => NEEDS_ATTENTION_STATUSES.has(channel.status))
    .length;
